import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-preview-whatsapp-template',
  templateUrl: './preview-whatsapp-template.component.html',
  styleUrls: ['./preview-whatsapp-template.component.scss']
})
export class PreviewWhatsappTemplateComponent {

    @Input() whatsappPreviewTemplate: any;

    templateType: any = '';
    mediaId: any = '';
    header: any = '';
    footer: any = '';
    quickReplyButtons: any = [];
    urlButtons: any = [];
    callButtons: any = [];
    countQuickReplyButton: any = 0;
    countCTAButtonForURL: any = 0;
    renderedData: any = '';
    template: any = '';
    currentTime: any = '';
    timerId: any;
    showAllVariables: any = false;
@Output() close: EventEmitter<any> = new EventEmitter();


    cards: any[] = [];
    previewCarouselIndex: number = 0;

    ngOnInit(): void {
      this.handleOpenPreviewDialog(this.whatsappPreviewTemplate);
      this.template = this.whatsappPreviewTemplate;
      this.updateTime();
      this.timerId = setInterval(() => this.updateTime(), 60000); // Update every minute
    }

    updateTime() {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const formattedHours = hours % 12 || 12; // Convert 24-hour to 12-hour format
      const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  
      this.currentTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
    }

    handleOpenPreviewDialog(template: any) {
      if (!template) return;
      this.templateType = template.templateType;
  
      if (template.templateType === 'IMAGE' || template.templateType === 'VIDEO' || template.templateType === 'DOCUMENT' || template.templateType === 'GIF') {
        try {
          const data = typeof template.meta === 'string' ? JSON.parse(template.meta) : (template.meta || {});
          this.mediaId = data.mediaId;
        } catch (_) {}
      }

      if (template.templateType === 'CAROUSEL') {
        const rawCards = template.cards || template.template_data?.cards || [];
        this.cards = rawCards.map((c: any, idx: number) => ({
          id: idx + 1,
          mediaId: c.mediaId || '',
          mediaUrl: c.mediaUrl || (c.mediaId ? `https://filemanager.gupshup.io/fm/wamedia/${template.app_name || 'app'}/${c.mediaId}` : ''),
          body: c.body || '',
          buttons: (c.buttons || []).map((b: any) => ({
            type: b.type || 'URL',
            text: b.text || '',
            url: b.url || ''
          }))
        }));
      }

      const { header, body, footer } = this.splitString(template.containerMeta);
      this.header = header || template.header || '';
      this.footer = footer || template.footer || '';
      const { quickReplyButtons, urlButtons, callButtons } = this.parseButtons(template.containerMeta);
  
      this.quickReplyButtons = quickReplyButtons.map((button: string) => ({ value: button }));
      this.urlButtons = urlButtons.map((button: any) => ({ title: button.text, urlType: button.urlType, value: button.url }));
      this.callButtons = callButtons.map((button: any) => ({ title: button.text, value: button.url }));
  
      this.countQuickReplyButton = this.quickReplyButtons.length;
      this.countCTAButtonForURL = this.urlButtons.length;
  
      const mainText = body || template.content || template.template_data?.content || '';
      this.renderedData = this.formateData(mainText);
    }

    scrollCarouselPreview(direction: 'left' | 'right'): void {
      if (direction === 'left' && this.previewCarouselIndex > 0) {
        this.previewCarouselIndex--;
      } else if (direction === 'right' && this.previewCarouselIndex < this.cards.length - 1) {
        this.previewCarouselIndex++;
      }
      const track = document.querySelector('.preview-box .wa-carousel-cards-track');
      if (track) {
        const scrollAmount = 210;
        track.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
      }
    }

    onCarouselTrackScroll(event: any): void {
      const element = event.target;
      this.previewCarouselIndex = Math.round(element.scrollLeft / 210);
    }

    getCardImageUrl(card: any): string {
      if (!card) return 'assets/img/Gallary.png';
      if (card.mediaData && typeof card.mediaData === 'string' && card.mediaData.trim().length > 0) {
        return card.mediaData;
      }
      if (card.mediaUrl && typeof card.mediaUrl === 'string' && card.mediaUrl.trim().length > 0) {
        if ((card.mediaUrl.includes('/wamedia/app/') || card.mediaUrl.includes('/wamedia//')) && card.mediaId) {
          return `https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/${card.mediaId}?download=false`;
        }
        return card.mediaUrl;
      }
      if (card.mediaId) {
        return `https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/${card.mediaId}?download=false`;
      }
      return 'assets/img/Gallary.png';
    }

    onCardImageError(event: any, card: any): void {
      const target = event?.target as HTMLImageElement;
      if (!target) return;
      if (card?.mediaId && !target.src.includes('/wa/media/' + card.mediaId)) {
        target.src = `https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/${card.mediaId}?download=false`;
        return;
      }
      if (!target.src.includes('Gallary.png')) {
        target.src = 'assets/img/Gallary.png';
        target.style.objectFit = 'contain';
        target.style.padding = '20px';
      }
    }

    formateData(data: any) {
      return data
        .replace(/\n/g, '<br>') // Replace \n with <br>
        .replace(/\*(.*?)\*/g, '<b>$1</b>'); // Replace *text* with <b>text</b>
    }
  
    parseButtons(input: string): {
      quickReplyButtons: string[], urlButtons: { text: string, urlType: string, url: string }[],
      callButtons: { text: string, url: string }[]
    } {
      const quickReplyButtons: string[] = [];
      const urlButtons: { text: string, urlType: string, url: string }[] = [];
      const callButtons: { text: string, url: string }[] = [];
  
      // Parse the input string as JSON
      const inputData = JSON.parse(input);
  
      // Assuming buttons field is present in the input JSON
      const { buttons } = inputData;
  
  
      if (buttons) {
        buttons.forEach((button: any) => {
          if (button.type === 'QUICK_REPLY') {
            // Add to quickReplyButtons if type is QUICK_REPLY
            quickReplyButtons.push(button.text.trim());
          } else if (button.type === 'URL') {
            // Add to urlButtons if type is URL
            urlButtons.push({ text: button.text.trim(), urlType: "static", url: button.url.trim() });
          } else if (button.type === 'PHONE_NUMBER') {
            // Add to urlButtons if type is URL
            callButtons.push({ text: button.text, url: button.phone_number });
          }
        });
      }
  
      return { quickReplyButtons, urlButtons, callButtons };
    }

    splitString(inputString: any) {

      // Parse the input string as JSON
      const inputData = JSON.parse(inputString);
  
      // Extract the header, body (data), and footer from the JSON object
      const { header, data: body, sampleText, footer } = inputData;
  
      return {
        header: header,
        body: this.updateSampleText(sampleText),
        footer: footer
      };
    }

    updateSampleText(input: string): string {
      return input.replace(/\[(.*?)\]/g, '$1');
    }

    showAllOptions() {
      this.showAllVariables = !this.showAllVariables;
    }
  
   closePopup() { this.close.emit()}
}
